import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { FastMovingItemDto } from '../types';

interface FastMovingItemsTableProps {
  data: FastMovingItemDto[];
}

export function FastMovingItemsTable({ data }: FastMovingItemsTableProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Fast-Moving Items</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-4 py-2 text-left font-medium">Item</th>
                <th className="px-4 py-2 text-right font-medium">Issued</th>
                <th className="px-4 py-2 text-right font-medium">Avg/Day</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan={3} className="px-4 py-8 text-center text-muted-foreground">
                    No data available
                  </td>
                </tr>
              ) : (
                data.map((item) => (
                  <tr key={item.netsuiteItemId} className="border-b hover:bg-muted/50">
                    <td className="px-4 py-2">
                      <div>
                        <p className="font-medium">{item.itemCode}</p>
                        <p className="text-xs text-muted-foreground truncate max-w-[200px]">
                          {item.itemName}
                        </p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-right font-medium">
                      {item.totalIssued.toLocaleString()} {item.unitOfMeasure}
                    </td>
                    <td className="px-4 py-2 text-right text-muted-foreground">
                      {item.avgPerDay.toFixed(1)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
